import { useState, useRef } from 'react';
import { useMeeting } from "@videosdk.live/react-sdk";

import ParticipantView from "./ParticipantView";
import Controls from "./Controls";

// HOOKS
import useUpdate from "../../hooks/useUpdate";
import Spinner from "../../components/Spinner";
import useSendPushNotification from '../../hooks/useSendPushNotification';



const MeetingView = (props) => {

    
    console.log("selectedItem",props.selectedItem);

    
    const { updateData, isLoading, errorMessage, successMessage, responseData } = useUpdate('patch');
    const { sendPushNotification, response, error } = useSendPushNotification();
    

    const [joined, setJoined] = useState(null);
    //Get the method which will be used to join the meeting.
    //We will also get the participants list to display all participants
    const { join, participants } = useMeeting({
        //callback for when meeting is joined successfully
        onMeetingJoined: () => {
            setJoined("JOINED");
            handleOpenWindow();
        },
        //callback for when meeting is left
        onMeetingLeft: () => {
            props.onMeetingLeave();
        }
    });
    const joinMeeting = () => {
        setJoined("JOINING");
        //join();
        handleOpenWindow()
    };








    const handleSendMeetingID = async (meetingId) => {     

        const participantsProfileIds = props.participantsProfileIds;
        console.log(participantsProfileIds);
        const uniqueUserProfilesWithIds = [...new Map(participantsProfileIds.map(item => [item.user_profile, item])).values()];


        const transactionIds = participantsProfileIds.map(item => item.transaction_id);
        const url = `${process.env.REACT_APP_API_URL}/transactions/update_multiple/`; // Adjust URL as necessary

        try {
          await updateData(url, { transaction_ids: transactionIds, meeting_id: meetingId }, () => {
          }, 'patch');
        } catch (error) {
          console.error('Update failed:', error);
        }


        for (let i = 0; i < uniqueUserProfilesWithIds.length; i++) {
            console.log(uniqueUserProfilesWithIds[i].registration_id);
            //props.sendNotification('sendTransaction',uniqueUserProfilesWithIds[i]['transaction_id'], uniqueUserProfilesWithIds[i]['user_profile_id']);
            sendPushNotification(uniqueUserProfilesWithIds[i].registration_id, "","Meeting ID", `This is your meeting ID: ${meetingId}`, "MEETING ID", "notification_user")
        }
      };


    const {localParticipant } = useMeeting({});


    const spanRef = useRef(null);
    const [tooltipVisible, setTooltipVisible] = useState(false);

    const handleCopy = async () => {
        try {
            const textToCopy = spanRef.current.textContent;
            await navigator.clipboard.writeText(textToCopy);
            setTooltipVisible(true);
            setTimeout(() => setTooltipVisible(false), 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };



    const [isWindowClosed, setIsWindowClosed] = useState(false);
    const newWindow = useRef(null); // Using useRef to persist the window reference across renders


    const [isOpenMeeting,setIsOpenMeeting] = useState(false);
    const handleOpenWindow = () => {
        setIsOpenMeeting(true);

      if (newWindow.current && !newWindow.current.closed) {

        // Focus the window if it's already open
        newWindow.current.focus();
        console.log("Window is already open, focused.");
        return;
      }




      const currentUrl = window.location.origin; // Get the base URL (http://localhost:3000)
      let relativeUrl = `/iusevolutione/vcp/${props.meetingId}/${props.selectedItem.id}/${props.selectedItem.transaction_id}`;

      let fullUrl = `${currentUrl}${relativeUrl}`; // Concatenate
      const windowFeatures = "width=980,height=900,scrollbars=yes,resizable=yes";
      newWindow.current = window.open(fullUrl, "_blank", windowFeatures);





        // Periodically check if the window is closed
        const checkWindowClosed = setInterval(() => {
            if (newWindow.current && newWindow.current.closed) {
                setIsOpenMeeting(false);
                setIsWindowClosed(true); // Mark window as closed
                clearInterval(checkWindowClosed); // Stop checking
                console.log("Window is closed.");
            }
        }, 1000); // Check every second
    };



    return (
        <div className="col-12 mt-3" >
            


            {
                joined && joined == "JOINED" ? (
                    <div>

                        <div className="d-flex flex-column flex-md-row gap-4 text-nowrap flex-wrap flex-md-nowrap flex-lg-wrap flex-xxl-nowrap mb-4">
                            <div className="list-content">
                                <h5 className="card-title mb-0">Meeting ID: <span className="text-info" ref={spanRef}>{props.meetingId}</span>
                                    <span className="cursor-pointer btn rounded-pill btn-icon btn-label-secondary ms-2" title="Copy Meeting ID" onClick={handleCopy}><i className="bx bx-copy"></i></span>
                                </h5>
                                {tooltipVisible && (
                                    <small className="px-1 rounded bg-label-success position-absolute mt-n2">
                                        Copied
                                        <i className='bx bx-check mb-1' ></i>
                                    </small>
                                )}

                            </div>
                            <button className=" btn btn-label-warning btn-sm h-75" onClick={() => { handleSendMeetingID(props.meetingId) }}>
                                <i className="bx bx-rotate-right bx-sm align-middle scaleX-n1-rtl me-2" /><span>Notify Meeting ID to clients</span>
                            </button>
                        </div>

                        {/* For rendering all the participants in the meeting */}
                        <Controls handleCopy={handleCopy} />
                        {/*                         
                                {[...participants.keys()].map((participantId) => (
                                    <ParticipantView
                                        participantId = {participantId}
                                          // participantId="ggkudasai"
                                        key                  = {participantId}
                                        handleAdminBase64    = {props.handleAdminBase64}
                                        adminBase64Image     = {props.adminBase64Image}
                                        transactionsForOath  = {props.transactionsForOath}
                                        sendPushNotification = {props.sendPushNotification}
                                        handleMergedData     = {props.handleMergedData}
                                        clearArray           = {props.clearArray}

                                        
                                    />
                                ))} */}
                    </div>
                ) :

                    // joined && joined == "JOINING" ? (
                    //     <Spinner/>
                    // ) : (

                    <>


                        <div className="list-content d-none">
                            <h5 className="card-title mb-0">Meeting ID: <span className="text-info" ref={spanRef}>{props.meetingId}</span>
                                <span className="cursor-pointer btn rounded-pill btn-icon btn-label-secondary ms-2" title="Copy Meeting ID" onClick={handleCopy}><i className="bx bx-copy"></i></span>
                            </h5>
                            {tooltipVisible && (
                                <small className="px-1 rounded bg-label-success position-absolute mt-n2">
                                    Copied
                                    <i className='bx bx-check mb-1' ></i>
                                </small>
                            )}
                        </div>



                        {/* <button type='button' className="w-100 btn btn-label-warning btn-sm h-100" onClick={() => { handleSendMeetingID(props.meetingId) }}>
                                                <i className="bx bx-rotate-right bx-sm align-middle scaleX-n1-rtl me-2" /><span>Notify Meeting ID to principal</span>
                                            </button> */}


                        {isOpenMeeting ?
                            <button type='button' className="w-100 btn btn-label-primary h-100" onClick={joinMeeting}>
                                <span className="me-2">Meeting is on-going, click to focus</span><i className="bx bx-chevron-right bx-sm lh-1 scaleX-n1-rtl" />
                            </button>
                        
                        :
                            <button type='button' className="w-100 btn btn-label-primary h-100" onClick={joinMeeting}>
                                <span className="me-2">Join</span><i className="bx bx-chevron-right bx-sm lh-1 scaleX-n1-rtl" />
                            </button>
                        }

                      


                        {/* <button type='button'  className="w-100 btn btn-label-danger h-100"  onClick={()=>{hanleMakeAnotherTransaction()}}>
                                                <span className="me-2">End the meeting and make another Transaction</span><i className="bx bx-chevron-left bx-sm lh-1 scaleX-n1-rtl" />
                                            </button> */}

                    </>
                //)
            }



            {/* THIS IS RUNNING FOR WEB ONLY HD CAPTURE USING CAMERA OF CLIENT */}
            {/* <CaptureImageListner  localParticipantId={localParticipant?.id} /> */}
            {/* <div className="col-md-4"> <ShowImage /> </div> */}
        </div>
    );
    

}
 
export default MeetingView;